<template>
    <div class="score-block">
        <div class="score-block__icon">
            <svg-icon
                :icon="icon"
                :color="color"
            />
        </div>
        <div class="score-block__text">
            <text-decorator :size="FontSize.sm">
                {{ score.label }}
            </text-decorator>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { Score } from '@keyvue/one-api-client';
    import {
        Color,
        SvgIcon,
        TextDecorator,
        FontSize,
    } from '@keyvue/one-ui';

    import IconPositive from '@keyvue/one-material-icons/icons/sentiment_satisfied.svg?component';
    import IconNegative from '@keyvue/one-material-icons/icons/sentiment_dissatisfied.svg?component';
    import IconNeutral from '@keyvue/one-material-icons/icons/sentiment_neutral.svg?component';

    export interface Props {
        score: Score
    }
    const props = defineProps<Props>();

    const iconMap = {
        [Score.POSITIVE.value]: IconPositive,
        [Score.NEGATIVE.value]: IconNegative,
        [Score.NEUTRAL.value]: IconNeutral,
    };

    const colorMap = {
        [Score.POSITIVE.value]: Color.brandGreen,
        [Score.NEGATIVE.value]: Color.red500,
        [Score.NEUTRAL.value]: Color.orange500,
    };

    const icon = computed(() => iconMap[props.score.value]);
    const color = computed(() => colorMap[props.score.value]);
</script>

<style scoped lang="scss">
.score-block {
    display: flex;
    gap: size(sm);
    align-items: center;

    width: 100%;
    height: 100%;

    &__icon,
    &__text {
        display: flex;
        align-content: center;
        align-items: center;
        height: 100%;
    }

    &__icon {
        width: min-content;
    }
}
</style>
